import React from 'react'
import { HomeScreenWidget } from '~/models'
import './AgendaWidget'
import './MenuPageWidget'
import './FeedWidget'
import { getHomeScreenWidgetComponent } from './registry'

export function renderHomeScreenWidget(widget: HomeScreenWidget) {
  const Component = getHomeScreenWidgetComponent(widget.type)
  if (Component == null) {
    console.warn(`Cannot find widget component for widget "${widget.type}"`)
    return null
  }

  return React.createElement(Component, {options: widget.options})
}